// extracted by mini-css-extract-plugin
module.exports = {"component":"action-btn_component__2mYQh","icon":"action-btn_icon__2Nb80","text":"action-btn_text__LjXpe"};